import { render, staticRenderFns } from "./AdicionarPerimetro.vue?vue&type=template&id=61e84ba0&scoped=true"
import script from "./AdicionarPerimetro.vue?vue&type=script&lang=js"
export * from "./AdicionarPerimetro.vue?vue&type=script&lang=js"
import style0 from "./AdicionarPerimetro.vue?vue&type=style&index=0&id=61e84ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e84ba0",
  null
  
)

export default component.exports